<template>
  <div>
    <div class="d-none d-md-block pa-4 pa-md-2">
      <Breadcrumbs
        :headline="studentInfo.name"
        :link="[{ text: 'Học viên', href: '../students' }]"
      />
    </div>

    <v-card class="mb-2 mx-md-2">
      <v-tabs color="amber darken-1" v-model="tab">
        <v-tab href="#tab-1">Hồ sơ</v-tab>
        <v-tab href="#tab-2">Học Phí</v-tab>
        <v-tab href="#tab-3">Học Tập</v-tab>
        <v-tab href="#tab-4">Bảo Lưu</v-tab>
      </v-tabs>

      <v-tabs-items class="pa-2" v-model="tab">
        <v-tab-item key="1" value="tab-1">
          <student-profile :student="studentInfo" />
        </v-tab-item>
        <v-tab-item key="2" value="tab-2">
          <tuition-history :student="studentInfo"></tuition-history>
        </v-tab-item>
        <v-tab-item key="3" value="tab-3">
          <student-majors :studentId="student.id" />
        </v-tab-item>
        <v-tab-item key="4" value="tab-4">
          <student-reserved :student="studentInfo" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import StudentMajors from '@/modules/student/class/Majors.vue'
import StudentProfile from '@/modules/student/profile/StudentProfile'
import StudentReserved from '@/modules/student/profile/StudentReserved.vue'
import TuitionHistory from '@/modules/student/tuition/Tuitions.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
export default {
  components: {
    StudentProfile,
    StudentMajors,
    TuitionHistory,
    StudentReserved,
    Breadcrumbs
  },
  computed: {
    ...mapGetters('student', ['student']),
    studentInfo() {
      return {
        ...this.student,
        data: this.student.data || {}
      }
    }
  },
  data() {
    return {
      tab: null
    }
  },
  async created() {
    this.refresh()
  },
  methods: {
    ...mapActions('student', ['updateStudent', 'fetchStudent', 'setTuitions']),
    reset() {
      this.$refs.form.reset()
    },
    async refresh() {
      this.setTuitions([])
      await this.fetchStudent(this.$route.params.id)
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    save(data) {
      data.handledDate = moment().toISOString()
      this.updateStudent({ ...this.student, ...data })
    },
    cancel() {
      this.state = false
    }
  }
}
</script>
